import { z } from 'zod';

export const GetIntegrationGuestRequestQuerySchema = z
  .object({
    firstName: z.string(),
    lastName: z.string(),
    reservationId: z.string(),
    emailAddress: z.string(),
    phoneNumber: z.string(),
    arrivalDate: z.string(),
    departureDate: z.string(),
    roomNumber: z.string(),
  })
  .partial()
  .strict();

export type GetIntegrationGuestRequestQuery = z.infer<typeof GetIntegrationGuestRequestQuerySchema>;

export const GetIntegrationGuestResponseSchema = z.object({
  data: z.array(
    z.object({
      reservationId: z.string(),
      confirmationId: z.string(),
      arrivalDate: z.string(),
      departureDate: z.string(),
      status: z.string(),
      firstName: z.string().optional(),
      lastName: z.string().optional(),
      email: z.string().optional(),
      phoneNumber: z.string().optional(),
      roomNumber: z.string().optional(),
    }),
  ),
});

export type GetIntegrationGuestResponse = z.infer<typeof GetIntegrationGuestResponseSchema>;
